import storage from 'services/storage/localStorage';

export const setDevices = (settings = {}) => storage.set('devices', JSON.stringify(settings));

export const setSkipCall = (skipNextTime) => storage.set('skipCallSettings', skipNextTime ? '1' : '0');

export const getDevices = () => JSON.parse(storage.get('devices'));

export const getSkipCall = () => storage.get('skipCallSettings');
